import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function Admin({ children }) {
    const userStatus = useSelector(state => state.profil.status);
    if (userStatus !== 'admin') return <Navigate to="/" replace />;
    return children;
}

export default Admin;